export class ActionRequest {
  constructor(
    public unitId: number,
    public profileId: number,
    public email: string,
    public mobile: string,
    public subject: string,
    public category: string,
    public details: string,
    public name: string,
    public expiryDate: string,
    public typeId: string,
    public documents: any[]
  ) { }
}

export class ActionRequestPageData {
  constructor(
    public propertyManager: string,
    public categories: string[]
  ) { }
}

export class StrataPlanRequest {
  constructor(
    public strataPlanNumber: string
  ) { }
}
export class RequestList {
  date: Date;
  status: string;
  subject: string;
  shortDesc: string;
  requestType: string;
  requestId: number;
}

export class RequestDetail {
  date: Date;
  status: string;
  subject: string;
  description: string;
  details: string;
  dueDate: Date;
  category: string;
  declinedReason: string;
  showExternal: string;
  requestType: string;
  requestId: number;
  document: Documents[];
}

export class Documents {
  id: string;
  name: string;
  extension: string;
  contentType: string;
  storageId: string;
}

